
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/safe-labs-terms",
      function () {
        return require("private-next-pages/safe-labs-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/safe-labs-terms"])
      });
    }
  